import React from "react";
// import './EmptyToDos.css';

function EmptyToDos() {
    return (
        <p>¡Crea tu primer ToDo!</p>
    );
};

export { EmptyToDos }